var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSpeakerColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.82 5.46484C19.8191 6.39653 20.6167 7.52304 21.1636 8.77489C21.7105 10.0267 21.9952 11.3774 21.9999 12.7435C22.0047 14.1096 21.7295 15.4622 21.1914 16.7178C20.6532 17.9734 19.8635 19.1055 18.8709 20.0441M16.092 8.39026C16.6915 8.94927 17.17 9.62518 17.4982 10.3763C17.8263 11.1274 17.9971 11.9378 18 12.7574C18.0028 13.5771 17.8377 14.3886 17.5148 15.142C17.1919 15.8954 16.7181 16.5746 16.1225 17.1378M7.4803 16.1852L9.15553 18.2583C10.0288 19.3391 10.4655 19.8794 10.848 19.9382C11.1792 19.9891 11.5138 19.8708 11.7394 19.6231C12 19.3369 12 18.6422 12 17.2527V8.30404C12 6.91459 12 6.21987 11.7394 5.93368C11.5138 5.68593 11.1792 5.56762 10.848 5.61853C10.4655 5.67736 10.0288 6.21771 9.15553 7.29841L7.4803 9.37151C7.30388 9.58983 7.21567 9.69899 7.10652 9.77754C7.00982 9.84713 6.90147 9.89888 6.78656 9.93036C6.65687 9.96588 6.51652 9.96588 6.23583 9.96588H4.8125C4.0563 9.96588 3.6782 9.96588 3.37264 10.0668C2.77131 10.2655 2.2996 10.7372 2.10094 11.3385C2 11.6441 2 12.0222 2 12.7784C2 13.5346 2 13.9127 2.10094 14.2182C2.2996 14.8196 2.77131 15.2913 3.37264 15.4899C3.6782 15.5909 4.0563 15.5909 4.8125 15.5909H6.23583C6.51652 15.5909 6.65687 15.5909 6.78656 15.6264C6.90147 15.6579 7.00982 15.7096 7.10652 15.7792C7.21567 15.8578 7.30388 15.9669 7.4803 16.1852Z",
    stroke: "#5E42E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpeakerColored);
export default __webpack_public_path__ + "static/media/ic_speaker_colored.375477fb60701ff7a8de235dda780218.svg";
export { ForwardRef as ReactComponent };